import { Component, computed, Input, inject } from '@angular/core';
import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { BusinessStatus } from '../../../_interfaces/business.interface';
import { RouterLink } from '@angular/router';
import { RegisterService } from '../../../_services/register-service/register.service';
import { ResendBtnComponent } from '../resend-btn/resend-btn.component';
import { helpCenterUrl } from '../../../_fixtures/project-fixtures';
import { Store } from '@ngxs/store';
import { AppSelectors } from '../../../store/app/app.selectors';

@Component({
  selector: 'app-business-status-block-overlay',
  imports: [RouterLink, NgOptimizedImage, ResendBtnComponent, AsyncPipe],
  templateUrl: './business-status-block-overlay.component.html',
})
export class BusinessStatusBlockOverlayComponent {
  readonly store = inject(Store);
  readonly registerService = inject(RegisterService);
  readonly shouldShow$ = this.store.select(AppSelectors.shouldShowStatusBlockOverlay);

  @Input() status!: BusinessStatus;

  resend$ = this.registerService.resendDirectorApproval();
  protected readonly BusinessStatus = BusinessStatus;
  readonly helpCenterUrl = helpCenterUrl;

  statusNew = computed(() => this.status === BusinessStatus.New || this.status === BusinessStatus.Reupload);
  statusDirectorApproval = computed(() => this.status === BusinessStatus.DirectorApproval);
  statusPaymentMissed = computed(() => this.status === BusinessStatus.PaymentMissed);
  statusDecommissionPending = computed(() => this.status === BusinessStatus.DecommissionPending);
  statusDecommissioned = computed(() => this.status === BusinessStatus.Decommissioned);
  statusCertNotVerified = computed(
    () => this.status === BusinessStatus.Rejected || this.status === BusinessStatus.Error,
  );
  statusCertAuthPending = computed(
    () =>
      this.status === BusinessStatus.Verified ||
      this.status === BusinessStatus.DirectorApproval ||
      this.status === BusinessStatus.DirectorPartialApproval ||
      this.status === BusinessStatus.DirectorError,
  );
}
